<template lang="pug">
  b-row()
    //- Sección 1
    b-col(cols="12")
      b-row.row-title.pb-3
        b-icon-clock-history.mr-2
        h3.title Historial


      //- Tabla de Historial de Acciones y Estados
      b-row
        b-table(hover :items="ovData.historial_acciones" :fields="fields")


</template>

<script>

export default {
  props: {
    ov: {
      type: Object,
      required: true,
    },
  },

  components: {
  },
  data() {
    return {
      fields: [
        { key:'fecha_hora' ,label: 'Fecha y Hora' },
        { key:'accion' ,label: 'Acción' },
        { key:'estado_actual' ,label: 'Estado Actual' },
        { key:'estado_anterior' ,label: 'Estado Anterior' },
        { key:'usuario' ,label: 'Responsable' },
      ],
    }
  },

  computed: {
    ovData () {
      // Mantener todos los datos originales y agregar historial_acciones desde historial_completo
      const historial = Array.isArray(this.ov.historial_completo)
        ? this.ov.historial_completo.map(item => {
            let fechaFormateada = '-';
            if (item.fecha_hora) {
              const fecha = new Date(item.fecha_hora);
              fechaFormateada = fecha.toLocaleString('es-CL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              });
            }
            return {
              fecha_hora: fechaFormateada,
              tipo: item.tipo === 'CAMBIO_ESTADO' ? 'Cambio de Estado' : 'Acción',
              accion: item.accion,
              estado_actual: item.estado_actual || '-',
              estado_anterior: item.estado_anterior || '-',
              usuario: item.responsable?.nombre_completo || '-',
            }
          })
        : [];
      return {
        historial_acciones: historial,
        comentario_vendedor: this.ov.comentario_vendedor || '-',
        comentario_cierre: this.ov.comentario_cierre || '-',
        requiere_abono: this.ov.requiere_abono ? 'Sí' : 'No',
        abono_requerido: this.ov.abono_requerido ? `${this.ov.abono_requerido * 100}%` : '0%',
        monto_abonado: this.ov.monto_abonado || '0',
        monto_total_neto: this.ov.monto_total_neto || '0',
        iva: Number(this.ov.monto_total_neto) ? Math.floor(Number(this.ov.monto_total_neto) * 0.19).toString() : '0',
        monto_total_general: Number(this.ov.monto_total_neto) ? Math.floor(Number(this.ov.monto_total_neto) * 1.19).toString() : '0',
        productos: this.ov.detalle_venta,
        rut: this.ov.rut || '',
        nombre: this.ov.nombre || '',
        apellido: this.ov.apellido || '',
        correo_electronico: this.ov.correo_electronico || '',
        telefono: this.ov.telefono || '',
        region: this.ov.region || '',
        comuna: this.ov.comuna || '',
        direccion: this.ov.direccion || '',
        comentario: this.ov.comentario || '-',
        numero_serie_equipo: this.ov.numero_serie_equipo || '-',
        comentario_cliente: this.ov.comentario || '-',
        repuestos: this.ov.repuestos,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.label-text {
  color: $samtek-black !important;
}
.title {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}
.row-title {
  align-items: center;
}
.data-label {
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  justify-content: left;
  color: #525252;
  margin: 0;
}
.data-info {
  font-size: 14px;
  font-weight: 400;
  color: #525252;
  text-align: left;
}
.repuesto {
  color: #525252;
  font-size: 1rem;
}
.product-code {
  font-size: 11px;
  font-weight: 500;
  color: #525252;
}
.product-name {
  font-size: 14px;
  color: #23201C;
  font-weight: 500;
}
.total-table-label {
  font-size: 14px;
  font-weight: 700;
  text-align: start;
}
.total-table-info {
  font-size: 13px;
  font-weight: 500;
  color: #23201C;
  text-align: end;
}

.tipo-badge {
  font-size: 12px;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 6px;
  width: 100%;
}

.estado-badge {
  font-size: 11px;
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 4px;
}
</style>
